




import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
@Component({
  name: "badge"
})
export default class Badge extends Vue {
  @Prop({ default: 0 }) number: number;

  public get numberVal(): number {
    let flag =
      this.number &&
      typeof this.number === "number" &&
      /(^[1-9]\d*$)/.test(this.number.toString());
    if (flag) {
      return this.number;
    }
    return 0;
  }
  public get numberState(): number | Boolean {
    return !!this.numberVal;
  }
}
